export class BusinessUnitsWatcher {
  protected businessUnitsEntries: Map<string, Set<string>>
  protected maxEntriesInBusinessUnit: number

  constructor(businessUnits: string[], maxEntriesInBusinessUnit: number) {
    this.businessUnitsEntries = new Map(businessUnits.map((i) => [i, new Set<string>()]))
    this.maxEntriesInBusinessUnit = maxEntriesInBusinessUnit
  }

  public getEntries(businessUnit: string) {
    const entries = this.businessUnitsEntries.get(businessUnit)
    if (!entries) {
      throw new Error(`Business unit '${businessUnit}' does not exist`)
    }

    return entries
  }

  public initEntries(entries: string[]) {
    entries.forEach((entry) => {
      const businessUnit = this.getBusinessUnitInEntry(entry)
      if (businessUnit && !this.isBusinessUnitFull(businessUnit)) {
        this.addEntry(businessUnit, entry)
      }
    })
  }

  public addEntry(businessUnit: string, entry: string) {
    const entries = this.getEntries(businessUnit)
    entries.add(entry)
  }

  public isBusinessUnitFull(businessUnit: string) {
    const entries = this.getEntries(businessUnit)

    return entries.size === this.maxEntriesInBusinessUnit
  }

  public removeEntryIfExists(entry: string) {
    const businessUnit = this.getBusinessUnitInEntry(entry)
    if (businessUnit) {
      const entries = this.getEntries(businessUnit)
      entries.delete(entry)
    }
  }

  public resetEntries() {
    for (const [i] of this.businessUnitsEntries) {
      this.businessUnitsEntries.set(i, new Set())
    }
  }

  public getBusinessUnitInEntry(entry: string) {
    let result = null
    for (const [businessUnit] of this.businessUnitsEntries) {
      if (entry.startsWith(businessUnit)) {
        result = businessUnit
        break
      }
    }

    return result
  }
}
